import Vue from 'vue'
// import VueRouter from 'vue-router'
import router from './components/home/router'
import App from './App_home.vue'
import axios from 'axios';
import 'element-ui/lib/theme-chalk/display.css';

import store from './store/home/index';

import fun from './assets/js/code';
Vue.prototype.$code=fun;
// import './assets/css/common.less'
import VueSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
Vue.use(VueSwiper)
axios.defaults.withCredentials=true;
Vue.prototype.axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

router.afterEach(()=>{
    window.scrollTo(0,0)
})

Vue.use(ElementUI);
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
